/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $JuridicNature = {
  properties: {
    code: {
      type: 'number',
      isRequired: true,
    },
    description: {
      type: 'string',
      isRequired: true,
    },
  },
} as const;
